import { useDidMount } from 'utils/hooks';

export const useDocumentActionsRemoveUserFolderLifecycle = ({ handlers }) => {
  useDidMount(handlers.handleFetchCurrentFolder);
};
